import { useState } from 'react';
import { SpinnerGap, Stop, Ticket } from '@phosphor-icons/react';
import { FARBE } from '../pille-stil';
import { timerText } from '../../../lib/tickets/darstellung';

interface TimerContentProps {
  /** Beginn des laufenden Timers (ISO) */
  beginn: string;
  jetzt: Date;
  ticketNummer: string | null;
  /** schmale Pille (Handy): ohne das Wort „Ticket“ */
  schmal: boolean;
  onOeffnen: () => void;
  onStoppen: () => Promise<boolean>;
}

/** Ruhende Pille mit laufendem Ticket-Timer (Handoff Tickets §7): „● 0:12:34 · Ticket T-0192“ + Stopp.
 *  Tipp auf Punkt/Uhr öffnet wie immer die Pille (Menü muss jederzeit erreichbar sein), der Ticket-Knopf
 *  springt zum Ticket bei den Zeiten, der rote Knopf stoppt und bucht. */
export function TimerContent({ beginn, jetzt, ticketNummer, schmal, onOeffnen, onStoppen }: TimerContentProps) {
  const [stoppt, setStoppt] = useState(false);
  const [fehler, setFehler] = useState(false);
  const dauer = timerText(jetzt.getTime() - new Date(beginn).getTime());
  const nummer = ticketNummer || 'Ticket';

  return (
    <div className="flex h-full items-center" style={{ gap: 8, padding: '0 5px 0 14px' }}>
      {/* Punkt + Uhr sind KEIN eigener Knopf: ein Tipp dort öffnet wie immer die Pille (Menü) */}
      <span className="flex min-w-0 flex-1 items-center" style={{ gap: 8 }}>
        <span className="relative flex shrink-0" style={{ width: 8, height: 8 }} aria-hidden>
          <span className="absolute inset-0 rounded-full pille-ping" style={{ background: fehler ? FARBE.rotHell : FARBE.gruen }} />
          <span className="relative rounded-full" style={{ width: 8, height: 8, background: fehler ? FARBE.rotHell : FARBE.gruen, boxShadow: `0 0 8px ${fehler ? FARBE.rotHell : FARBE.gruen}` }} />
        </span>
        <span className="shrink-0 tabular-nums" style={{ fontSize: 14, fontWeight: 800 }}>{dauer}</span>
        {fehler && <span className="truncate" style={{ fontSize: 12, fontWeight: 600, color: FARBE.rotHell }}>Stoppen fehlgeschlagen</span>}
      </span>
      {!fehler && (
        <button type="button" data-tip="Laufender Timer – Klicken öffnet das Ticket bei den Zeiten"
          aria-label={`${nummer} – Ticket bei den Zeiten öffnen`}
          onClick={(e) => { e.stopPropagation(); onOeffnen(); }}
          onKeyDown={(e) => e.stopPropagation()}
          className="flex min-w-0 shrink items-center"
          style={{ gap: 5, height: 26, padding: '0 9px', borderRadius: 13, border: 'none', cursor: 'pointer', fontFamily: 'inherit',
            background: 'rgba(255,255,255,0.12)', color: 'rgba(255,255,255,0.86)', fontSize: 12, fontWeight: 700 }}>
          <Ticket size={12} weight="bold" color={FARBE.gold} className="shrink-0" />
          <span className="truncate">{schmal ? nummer : `Ticket ${nummer}`}</span>
        </button>
      )}
      <button type="button" aria-label="Timer stoppen" data-tip="Timer stoppen – Zeit auf das Ticket buchen" disabled={stoppt}
        onKeyDown={(e) => e.stopPropagation()}
        onClick={async (e) => {
          e.stopPropagation();
          setStoppt(true);
          setFehler(false);
          const ok = await onStoppen();
          setStoppt(false);
          if (!ok) setFehler(true);
        }}
        className="inline-flex shrink-0 items-center justify-center"
        style={{ width: 28, height: 28, borderRadius: '50%', border: 'none', cursor: 'pointer', background: FARBE.rotHell, color: '#fff', boxShadow: `0 4px 12px -4px ${FARBE.rotHell}` }}>
        {stoppt ? <SpinnerGap size={13} className="animate-spin" /> : <Stop size={12} weight="fill" />}
      </button>
    </div>
  );
}
